import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {CourseType, CourseTypesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GET_COURSETYPE_URL = `${API_URL}/coursetype/getcoursetype`
const CREATE_COURSETYPE_URL = `${API_URL}/coursetype/addcoursetype`
const UPDATE_COURSETYPE_URL = `${API_URL}/coursetype/updatecoursetype`
const DELETE_COURSETYPE_URL = `${API_URL}/coursetype/deletecoursetype`
const GET_COURSETYPES_URL = `${API_URL}/coursetype/getcoursetypes`

const getCourseTypes = (query: string): Promise<CourseTypesQueryResponse> => {
  return axios
    .get(`${GET_COURSETYPES_URL}?${query}`)
    .then((d: AxiosResponse<CourseTypesQueryResponse>) => d.data)
}

const getCourseTypeById = (id: ID): Promise<CourseType | undefined> => {
  return axios
    .get(`${GET_COURSETYPE_URL}/${id}`)
    .then((response: AxiosResponse<Response<CourseType>>) => response.data)
    .then((response: Response<CourseType>) => response.data)
}

const createCourseType = (coursetype: CourseType): Promise<CourseType | undefined> => {
  return axios
    .post(CREATE_COURSETYPE_URL, coursetype)
    .then((response: AxiosResponse<Response<CourseType>>) => response.data)
    .then((response: Response<CourseType>) => response.data)
}

const updateCourseType = (coursetype: CourseType): Promise<CourseType | undefined> => {
  return axios
    .put(`${UPDATE_COURSETYPE_URL}/${coursetype.id}`, coursetype)
    .then((response: AxiosResponse<Response<CourseType>>) => response.data)
    .then((response: Response<CourseType>) => response.data)
}

const deleteCourseType = (coursetypeId: ID): Promise<void> => {
  return axios.delete(`${DELETE_COURSETYPE_URL}/${coursetypeId}`).then(() => {})
}

const deleteSelectedCourseTypes = (coursetypeIds: Array<ID>): Promise<void> => {
  const requests = coursetypeIds.map((id) => axios.delete(`${DELETE_COURSETYPE_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getCourseTypes, deleteCourseType, deleteSelectedCourseTypes, getCourseTypeById, createCourseType, updateCourseType}
